package com.lomdaat.ads.model

import kotlinx.serialization.Serializable

@Serializable
data class GeoPoint(
    val latitude: Double,
    val longitude: Double,
)

@Serializable
enum class BannerSize(val wireValue: String) {
    BANNER("A"),
    LARGE_BANNER("B"),
    MEDIUM_RECTANGLE("C"),
}

@Serializable
data class AudioAd(
    val id: AdId,
    val title: String,
    val clickThroughUrl: String,
    val imageUrl: String?,
    val mediaUrl: String,
    val campaignId: CampaignId,
    val impressionUrl: String?,
)

@Serializable
data class NativeAd(
    val id: AdId,
    val title: String,
    val headline: String,
    val body: String?,
    val clickThroughUrl: String,
    val imageUrl: String,
    val campaignId: CampaignId,
    val impressionUrl: String?,
)

@Serializable
data class AudioAdRequest(
    val appId: AppId,
    val requestId: AdsRequestId?,
    val location: GeoPoint? = null,
)

@Serializable
data class NativeAdRequest(
    val appId: AppId,
    val requestId: AdsRequestId?,
    val location: GeoPoint? = null,
)

@Serializable
data class BannerAdRequest(
    val appId: AppId,
    val requestId: AdsRequestId?,
    val size: BannerSize,
    val reloadAutomatically: Boolean = true,
    val location: GeoPoint? = null,
)

@Serializable
data class InterstitialAdRequest(
    val appId: AppId,
    val requestId: AdsRequestId?,
    val hadran: Boolean = false,
    val location: GeoPoint? = null,
)

@Serializable
data class VideoAdTagRequest(
    val appId: AppId,
    val requestId: AdsRequestId?,
    val durationMs: Long? = null,
    val clickUrlPrefix: String? = null,
    val location: GeoPoint? = null,
)

@Serializable
data class AdsIdentity(
    val requestId: AdsRequestId?,
    val trackingAllowed: Boolean,
)

@Serializable
data class VideoAd(
    val id: AdId?,
    val mediaUrl: String,
    val mimeType: String?,
    val durationMs: Long?,
    val skipOffsetMs: Long?,
    val impressionUrl: String?,
    val clickThroughUrl: String?,
    val clickTrackingUrl: String?,
    val width: Int?,
    val height: Int?,
)
